import { useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import { Checkbox } from "../Checkbox";
import { Type } from "../Type";

export type Props = {
  value?: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export function RadioGroupItem({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  className,
}: Props) {
  const cardRef = useRef<HTMLDivElement>(null);

  const [hasFocus, setHasFocus] = useState(false);

  const handleCardClick = () => {
    if (!disabled) {
      onChange(!checked);
      cardRef.current?.focus();
    }
  };

  return (
    <div
      ref={cardRef}
      title={label}
      onClick={handleCardClick}
      className={twMerge(
        "flex items-center border rounded-lg p-4 shadow-md transition-shadow focus:outline-none",
        !disabled && "hover:shadow-lg cursor-pointer",
        hasFocus &&
          "outline-offset-4 ring-offset-2 ring-2 ring-brand-600 ring-offset-brand-50 outline-brand-600 outline-0",
        checked && "border-brand-600 border-2",
        disabled && !checked && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Checkbox
          name={`${label}-checkbox`}
          checked={checked}
          disabled={disabled}
          className="h-4 w-4 border-none shadow-none mr-1 pointer-events-none"
          ariaLabel={label}
          onFocus={() => setHasFocus(true)}
          onBlur={() => setHasFocus(false)}
        />
        <div>
          <Type variant="h5" as="div" className="text-brand-800 !font-medium">
            {label}
          </Type>
          {description && (
            <Type variant="caption" className="text-brand-800">
              {description}
            </Type>
          )}
        </div>
      </div>
    </div>
  );
}

export default RadioGroupItem;

